import {
  ContentPopper,
  ContentPopperProps,
  ModalDialogBodyContent,
  ModalDialogContent,
  SPACING,
  tabletAndUpLinaria,
} from '@aboutyou/ui-components';
import {styled} from '@linaria/react';
import React from 'react';
import {
  RedeemCoinsPopupContent,
  RedeemCoinsPopupContentProps,
} from './RedeemCoinsPopupContent';

export const RedeemCoinsPopup: React.FC<
  RedeemCoinsPopupContentProps & {
    isOpen: boolean;
    LayoutComponent: ContentPopperProps['LayoutComponent'];
  }
> = ({data, step, isOpen, LayoutComponent}) => {
  return (
    <StyledContentPopper
      data-testid="redeemCoinsPopup"
      aria-labelledby="focusableText"
      LayoutComponent={LayoutComponent}
      renderInPortal
      open={isOpen}
      onClose={() => {
        // do nothing: user can't manually close this
      }}
      bodyContent={
        <PopperContentContainer>
          <RedeemCoinsPopupContent data={data} step={step} />
        </PopperContentContainer>
      }
    />
  );
};

const StyledContentPopper = styled(ContentPopper)`
  ${ModalDialogContent} {
    width: 375px;
  }

  ${ModalDialogBodyContent} {
    line-height: unset;
    padding: 0;
    height: 100%;
    border-bottom: none;
  }
`;

const PopperContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 16px;
  padding: ${SPACING['Y.Xl']} ${SPACING['X.Md']};
  height: 286px;
  overflow: hidden;

  ${tabletAndUpLinaria(`
    height: 100%;
    max-height: 286px;
  `)}
`;
